import React, { FC, useState } from "react";
import greenMark from "../../../../assets/greenMark.svg";
import "./TableFilterItem.scss";
const TableFilterItem: FC<{
  title: string;
  amount?: number;
  onFilterItemSelect: (isActive: boolean) => void;
}> = ({ title, amount, onFilterItemSelect }) => {
  const [isActive, toggleIsActive] = useState(false);

  const selectFilterHandler = () => {
    onFilterItemSelect(!isActive);
    toggleIsActive((prevValue) => !prevValue);
  };

  return (
    <div className="table-filter-item">
      <button
        onClick={selectFilterHandler}
        className={`${
          isActive
            ? "table-filter-item__button table-filter-item__button--active "
            : "table-filter-item__button"
        }`}
      >
        {isActive && <img src={greenMark} />}
      </button>
      <div className="table-filter-item__text">
        <p className="table-filter-item__title-amount">{title}</p>
        {amount !== undefined && (
          <p className="table-filter-item__title-amount">({amount})</p>
        )}
      </div>
    </div>
  );
};

export default TableFilterItem;
